import { Assets } from '../../assets';
import { Flex } from '../Layout';

export const LoadingPage = ({ animation = 'loading' }: { animation?: 'loading' | 'spinner' }) => {
  return (
    <Flex justifyContent={'center'} paddingTop={[50, 150, 150]}>
      {animation === 'spinner' ? <Assets.Spinner strokeWidth={10} /> : <Assets.Loading width={120} color="black20" />}
    </Flex>
  );
};
